import { UseMutationOptions, useMutation } from "@tanstack/react-query"
import { AxiosError } from "axios"

import {
  UpdateProductionSiteFieldDefinition,
  UpdateProductionSiteFieldDefinitionParams,
} from "@tfg/types/schemas/modules/traceability/queries/update-production-site-field-definition.dto"

import { httpClient } from "~/backend/axios"
import { queryClient } from "~/backend/queryClient"
import { showAxiosError } from "~/utils/showAxiosError"
import { showSuccessNotification } from "~/utils/showSuccessNotification"

export const useUpdateProductionSiteFieldDefinitionMutation = (
  params: UpdateProductionSiteFieldDefinitionParams,
  options?: UseMutationOptions<
    unknown,
    AxiosError,
    UpdateProductionSiteFieldDefinition
  >
) =>
  useMutation({
    mutationFn: async (data: UpdateProductionSiteFieldDefinition) => {
      return await httpClient.put(
        `/admin/traceability/update-production-site-field-definition/${params.id}`,
        data
      )
    },
    onSuccess: (data, variables, onMutateResult, context) => {
      options?.onSuccess?.(data, variables, onMutateResult, context)
      queryClient.invalidateQueries({
        queryKey: ["prodSiteFieldDefs"],
      })
      showSuccessNotification({
        title: "Success",
        message: "Production field definition updated",
      })
    },
    onError: (error: AxiosError) => {
      showAxiosError({
        notificationTitle: "Error",
        notificationMessage: error.message,
        showNotification: true,
        error,
      })
    },
  })
